module.exports = __webpack_public_path__ + "img/tarjeta_ofertas_seguro_coche.f027c63f.jpg";